// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class UserNameIdentity implements flatbuffers.IUnpackableObject<UserNameIdentityT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): UserNameIdentity {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsUserNameIdentity(
    bb: flatbuffers.ByteBuffer,
    obj?: UserNameIdentity,
  ): UserNameIdentity {
    return (obj || new UserNameIdentity()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsUserNameIdentity(
    bb: flatbuffers.ByteBuffer,
    obj?: UserNameIdentity,
  ): UserNameIdentity {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new UserNameIdentity()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  username(): string;
  username(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  username(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  password(): string;
  password(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  password(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  static startUserNameIdentity(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addUsername(builder: flatbuffers.Builder, usernameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, usernameOffset, 0);
  }

  static addPassword(builder: flatbuffers.Builder, passwordOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, passwordOffset, 0);
  }

  static endUserNameIdentity(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // username
    builder.requiredField(offset, 6); // password
    return offset;
  }

  static createUserNameIdentity(
    builder: flatbuffers.Builder,
    usernameOffset: flatbuffers.Offset,
    passwordOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    UserNameIdentity.startUserNameIdentity(builder);
    UserNameIdentity.addUsername(builder, usernameOffset);
    UserNameIdentity.addPassword(builder, passwordOffset);
    return UserNameIdentity.endUserNameIdentity(builder);
  }

  unpack(): UserNameIdentityT {
    return new UserNameIdentityT(this.username(), this.password());
  }

  unpackTo(_o: UserNameIdentityT): void {
    _o.username = this.username();
    _o.password = this.password();
  }

  unpackFields(...fields: string[]): UserNameIdentityT {
    const t = new UserNameIdentityT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("username")) {
      t.username = this.username();
    }
    if (fieldSet.has("password")) {
      t.password = this.password();
    }
    return t;
  }
}

export class UserNameIdentityT implements flatbuffers.IGeneratedObject {
  constructor(
    public username: string | Uint8Array | null = null,
    public password: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.username === null || this.username === undefined) {
      throw new Error('Required field "username" is not set');
    }
    if (this.password === null || this.password === undefined) {
      throw new Error('Required field "password" is not set');
    }
    const username = this.username !== null ? builder.createString(this.username!) : 0;
    const password = this.password !== null ? builder.createString(this.password!) : 0;

    return UserNameIdentity.createUserNameIdentity(builder, username, password);
  }

  clone(): UserNameIdentityT {
    const obj = new UserNameIdentityT();
    obj.username = this.username;
    obj.password = this.password;
    return obj;
  }

  equals(other: UserNameIdentityT): boolean {
    if (this.username !== other.username) return false;
    if (this.password !== other.password) return false;
    return true;
  }
}

export function verifyUserNameIdentity(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "username");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "password");
  } finally {
    verifier.popDepth();
  }
}
